import { Text, Flex, Image, Button, Divider } from "@chakra-ui/react";
import { t } from "i18next";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";
import { FunnelContextArea } from "../funnel/types";
import { Release } from "../../types";
import { FunnelComponentProps } from "../funnel/types";
import { Trans } from "react-i18next";

export function GoldAccessBody({
  onSuccess,
  context,
  release,
  customCongratsImage,
}: FunnelComponentProps & {
  context?: string;
  release?: Release;
  customCongratsImage?: string;
}) {
  const isMobile = useMobileBreakpoint();

  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <Flex mt="24px" px="24px" alignItems="center" gap="16px">
        <Text variant="onboardingTitle" textAlign="center" fontSize="24px">
          <Trans
            i18nKey="components.goldAccess.title"
            components={{ 1: <br /> }}
          />
        </Text>
      </Flex>

      <Image
        src={
          customCongratsImage ??
          `${window.gc.global.assets_url}/static/images/web-ui/onboarding/onboardingSplashCovers.png`
        }
        marginTop="-30px"
        width="100%"
        height="auto"
        aspectRatio="512/300"
      />

      <Flex
        marginTop="-45px"
        flexDirection="column"
        gap="24px"
        width="100%"
        px={isMobile ? "24px" : "48px"}
        alignItems="center"
      >
        <Divider color="transparent.white.10" />
        <Button
          variant="primary"
          size="lg"
          onClick={() => onSuccess({})}
          width="100%"
          maxWidth="320px"
        >
          {context === FunnelContextArea.reader ||
          context === FunnelContextArea.verticalReader ||
          (release?.user_read_status?.count_pages_read ?? 0) > 0
            ? t("components.goldAccess.continueReading")
            : t("components.goldAccess.startReading")}
        </Button>
      </Flex>
    </Flex>
  );
}
